<template>
  <div v-if="chat" class="rightbar flex-none flex flex-column">
    <div class="flex-none">
      <ChatDetails :chat="chat"/>
      <ul class="nav" v-bind:class="{ 'show-none': !connected }">
        <li v-if="enabledDetails.includes('pet')">
          <router-link active-class="nav-link-active" class="nav-link" :to="createLinkTo({details: 'pet'})">
            Eläimen tiedot
          </router-link>
        </li>
        <li v-if="enabledDetails.includes('questionnaire')">
          <router-link active-class="nav-link-active" class="nav-link" :to="createLinkTo({details: 'questionnaire'})">
            Omistajan tiedot
          </router-link>
        </li>
      </ul>
    </div>

    <div class="flex-auto overflow-y">
      <PetDetails v-if="selectedDetails === 'pet'" :chat="chat" />
      <OwnerDetails v-else-if="selectedDetails === 'questionnaire'" :chat="chat" />
    </div>

    <div v-if="connected && !videoToken" class="flex-none ">
      <RightFooter v-if="['new', 'own', 'closed'].includes(chat.queue)" :chat="chat" :messages="messages" />
      <RightFooterAppointment v-else-if="chat.queue === 'appointment'" :chat="chat" :messages="messages" />
    </div>
  </div>
</template>

<script>
import ChatDetails from "@/components/reception/ChatDetails.vue";
import PetDetails from "@/components/reception/PetDetails.vue";
import OwnerDetails from "@/components/reception/OwnerDetails.vue";
import RightFooter from "@/components/reception/RightFooter.vue";
import RightFooterAppointment from "@/components/reception/RightFooterAppointment.vue";
import { mapGetters } from "vuex";

export default {
  name: "RightBar",
  components: { ChatDetails, PetDetails, OwnerDetails, RightFooter, RightFooterAppointment },
  props: {
    chat: Object,
    messages: Array,
    createLinkTo: Function,
    details: String,
  },
  computed: {
    enabledDetails() {
      return [
        'pet',
        ...(this.chat.queue !== 'new' ? ['questionnaire'] : []),
      ];
    },
    selectedDetails() {
      return this.enabledDetails.includes(this.details) ? this.details : this.enabledDetails[0];
    },
    ...mapGetters({
      connected: 'connected',
      videoToken: 'videoToken',
    })
  },
};
</script>

<style>
  :root {
    --rightbar-border-color: var(--gray-4);
    --rightbar-width: 16rem;
    --rightbar-width-xl: 20rem;
  }
</style>

<style scoped>
  .rightbar {
    width: var(--rightbar-width);
    border-left: 1px solid var(--gray-4);
  }

  .nav {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    box-shadow: 0 -1px 0 var(--rightbar-border-color);
  }

  .nav li {
    flex: auto;
  }

  .nav-link {
    display: block;
    padding: .75rem .25rem;
    text-align: center;
    font-weight: 600;
    font-size: .75rem;
    text-decoration: none;
    color: #00A1D4;
    text-transform: uppercase;
    background-color: var(--gray-6);
    box-shadow: inset 0 -1px 0 var(--rightbar-border-color);
}

  .nav-link.nav-link-active {
    background-color: var(--white);
  }

  .nav li:first-child .nav-link.nav-link-active {
    box-shadow: inset -1px 0 0 var(--rightbar-border-color);
  }

  .nav li:last-child .nav-link.nav-link-active {
    box-shadow: inset 1px 0 0 var(--rightbar-border-color);
  }

  @media (--breakpoint-xl) {
    .rightbar {
      width: var(--rightbar-width-xl);
    }
  }

  @custom-media --breakpoint-xl (min-width: 80em);

</style>
